import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { modifyLinkPropsForMode } from './utils/ProductUtils';

const ShopLink = ({ renderMode, shopWidgetSamePage, baseProps, children }) => {
  const linkProps = modifyLinkPropsForMode(baseProps, renderMode, shopWidgetSamePage);

  return <UX2.Element.Link { ...linkProps } children={ children } />;
};

ShopLink.propTypes = {
  renderMode: PropTypes.string,
  shopWidgetSamePage: PropTypes.bool,
  baseProps: PropTypes.object,
  children: PropTypes.any
};

export default ShopLink;
